import * as React from 'react';
import { withRouter, RouteComponentProps} from 'react-router-dom';
import { connect } from 'react-redux';
import * as ReactGA from 'react-ga';
import * as styles from 'layout/layoutPropsChildren.scss';
import { translate } from 'utils/translateUtil';
import Form from 'components/form/Form';
import { getCookie } from 'utils/cookieUtils';
import { ROUTES } from 'constants/routes';

type Props = {
	history: any;
	location: any;
	match: any;
	error?: any;
	isPending?: any;
	redirect?: boolean;
	config?: any;
};

type State = {
	login: any;
	global: any;
	config: any;
};

// additional named export to make it testable without redux connection.
export class Selfservice extends React.Component<RouteComponentProps<{}> & Props, any> {
	constructor(props: Props) {
		super(props);
	}
	public componentDidMount(){
		const verificationId = getCookie('Verification-Id');
		const verificationChallenge = getCookie('Verification-Challenge');
		if(!!!Object.keys(verificationId).length && !!!Object.keys(verificationChallenge).length){
			this.props.history.push(ROUTES.ERROR);
		}
		ReactGA.ga('event', 'select_content', {
            'content_type': 'self-auth',
		});
		
		this.setState({
			verificationId,
			verificationChallenge
		})
	}
	public render() {
		const { error, isPending, config, history } = this.props;
		return (
			<>
				<h1 className={styles.h1+ ' ' + styles.headlineWrapper}>
					{translate('main-page.welcome')}
				</h1>
				<p>
					{translate('main-page.subtitle')}
				</p>
				<Form history={history}cookies={{...this.state}}config={config} error={error} isPending={isPending} />
			</>
		);
	}
}

const mapStateToProps = (state: State, ownProps: Props) => {
	const loginState = state.login;
	const loginData = loginState.loginData;
	const config = state.config.config;
	return {
		error: loginState.error,
		isPending: loginState.pending,
		loginData,
		config
	};
};

export default withRouter<Props, any>(connect(mapStateToProps)(Selfservice as any) as any);
